module.exports = __webpack_public_path__ + "img/b94a400.jpg";